import Box from "@mui/material/Box";
import Loader from "./Loader";

const PageLoader = () => {
  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </Box>
  );
};

export default PageLoader;
